// mesbot/src/institution/api.js
const BASE = "/institution";

function authHeaders(token) {
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

export async function login(email, password) {
  const res = await fetch(`${BASE}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  if (!res.ok) throw new Error((await res.json()).detail || "Login failed");
  return res.json();
}

export async function logout(token) {
  await fetch(`${BASE}/auth/logout`, {
    method: "POST",
    headers: authHeaders(token),
  });
}

export async function getOverview(token) {
  const res = await fetch(`${BASE}/overview`, { headers: authHeaders(token) });
  if (!res.ok) throw new Error("Failed to load overview");
  return res.json();
}

export async function getWellness(token, weeks = 8) {
  const res = await fetch(`${BASE}/wellness?weeks=${weeks}`, {
    headers: authHeaders(token),
  });
  if (!res.ok) throw new Error("Failed to load wellness data");
  return res.json();
}

export async function getStudents(token) {
  const res = await fetch(`${BASE}/students`, {
    headers: authHeaders(token),
  });
  if (res.status === 403) throw Object.assign(new Error("DUA required"), { status: 403 });
  if (!res.ok) throw new Error("Failed to load students");
  return res.json();
}

export async function getStudentProfile(token, studentId) {
  const res = await fetch(`${BASE}/students/${studentId}`, {
    headers: authHeaders(token),
  });
  if (!res.ok) throw new Error("Failed to load student profile");
  return res.json();
}

export async function patchStudent(token, studentId, isActive) {
  const res = await fetch(`${BASE}/students/${studentId}`, {
    method: "PATCH",
    headers: authHeaders(token),
    body: JSON.stringify({ is_active: isActive }),
  });
  if (!res.ok) throw new Error("Failed to update student");
  return res.json();
}

export async function getSettings(token) {
  const res = await fetch(`${BASE}/settings`, { headers: authHeaders(token) });
  if (!res.ok) throw new Error("Failed to load settings");
  return res.json();
}

export async function patchSettings(token, updates) {
  const res = await fetch(`${BASE}/settings`, {
    method: "PATCH",
    headers: authHeaders(token),
    body: JSON.stringify(updates),
  });
  if (!res.ok) throw new Error("Failed to save settings");
  return res.json();
}
